import {getDate} from '../../../../../../@casino/lib/getDate';
import React from 'react';
import { parseLogin } from '../../../../../../@casino/lib/parseLogin';

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'date_event', label: 'Время'},
    { id: 'amount', label: 'Сумма'},
    { id: 'type', label: 'Тип транзакции'},
    { id: 'gamer', label: 'Игрок'},
    { id: 'group', label: 'Группа'},
];

const getTypeTransaction = (type) => {
    if (type.air && type.tag === 'replenishment') {
        return 'air_player_in';
    } else if (!type.air && type.tag === 'replenishment') {
        return 'player_in';
    } else if (type.air && type.tag === 'withdrawal') {
        return 'air_player_out';
    } else if (!type.air && type.tag === 'withdrawal') {
        return 'player_out';
    }
}

const getRows = (value) => {
    return value.map((item) => {
        return {
            id: item.id,
            date_event: getDate(+item.event_date),
            amount: new Intl.NumberFormat('ru-RU').format(item.summ) + '₽',
            type: <span style={{color: (getTypeTransaction(item) === 'player_in' || getTypeTransaction(item) === 'air_player_in') ? '#3cde0b' : 'red', display: 'flex'}}>
                {getTypeTransaction(item)}
                {
                    item.air_type && item.air_type === 'stock' ? <span style={{marginLeft: 12, width: 40, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 4, marginRight: 4}}>А</span> :
                    item.air_type && item.air_type === 'present' ? <span style={{marginLeft: 12, width: 40, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 4, marginRight: 4}}>П</span> :
                    item.air_type && item.air_type === 'lifting' ? <span style={{marginLeft: 12, width: 40, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', borderRadius: 4, marginRight: 4}}>С</span> : <></>   
                }
            </span>,
            gamer: parseLogin(item.event_cashier),
            group: item.groups,
        }
    })
} 

export {
    columns,
    getRows
}